<template>
  <div class="mapsvg-component" >
    <svg-vue class="italy" icon="italy" :class="{'out': activeRegion}"></svg-vue>

    <transition name="bounce" mode="out-in" @before-enter="setRegionProvincesFill">
      <svg-vue
        v-if="activeRegion"
        :icon="activeRegion"
        :key="activeRegion"
        class="region"
      ></svg-vue>
    </transition>
  </div>
</template>
<script>
import Vue from 'vue';
import { find, forIn } from 'lodash';
// https://v2.vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
// https://vuejs.org/guide/components/v-model.html

export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      places: {
        type: Object,
        default: {}
      }
    },
    components: {
    },
    computed: {
      activeRegion() {
        if (!this.value) {
          return '';
        } else if (this.places.hasOwnProperty(this.value)) {
          return this.value
        } else {
          let region = find(this.places, place => find(place.children, child => child.slug === this.value ))
          if (region) {
            return region.slug
          } else {
            return '';
          }
        }
      },
      provinces() {
        let p = []
        forIn(this.places, function(value, key) {
          p = p.concat(value.children)
        })
        return p
      }
    },
    watch: {
      value: {
        handler (vNew, vOld) {
          if (vOld) {
            this.setFill(vOld, '')
          }
          if (vNew) {
            this.setFill(vNew)
          }
        }
      },
      places: {
        handler (vNew, vOld) {
          this.setRegionsFill()
        }
      }
    },
    mounted () {
      this.$el.addEventListener('click', this.clickHandler)

      // initial region fill
      this.setRegionsFill()
      // initial region fill
      this.setRegionProvincesFill()
    },
    beforeDestroy () {
      this.$el.removeEventListener('click', this.clickHandler)
    },
    methods: {
      setRegionsFill() {
        if (this.places) {
            forIn(this.places, function(value, key) {
              const region = document.querySelector('.italy #' + value.slug)
              if (region) {
                region.dataset.active = value.slug
              }
            })
          }
      },
      setFill(selector, color = '#F7963E') {
        const pathList = document.querySelectorAll('[data-active="' + selector + '"]')
        if (pathList) {
          pathList.forEach(element => {
            element.style.fill = color;
          });
        }
      },
      async setRegionProvincesFill() {
        // region svg added to markup
        await Vue.nextTick()

        // DOM is now updated
        if (this.places.hasOwnProperty(this.activeRegion)) {
          const region = this.places[this.activeRegion]
          region.children.forEach(province => {
            const provinceEl = document.querySelector('#' + province.code.toLowerCase())
            if (provinceEl) {
              provinceEl.dataset.active = province.slug

              if (provinceEl.tagName.toLowerCase() === 'g') {
                const pathChildren = provinceEl.querySelectorAll('path')
                pathChildren.forEach(path => {
                  path.dataset.active = province.slug
                })
              }
            }
          });
        }

        this.setFill(this.value)
      },
      clickHandler (e) {
        // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
        // https://developer.mozilla.org/en-US/docs/Web/API/Event/eventPhase?retiredLocale=it
        // console.log(e.eventPhase)
        // console.log(e.currentTarget)
        // console.log(e.target)
        // e.eventPhase === 3 // bubbling to this.$el
        // if (e.target.tagName.toLowerCase() === 'path')
        let id
        if (e.target.dataset.active) {
          id = e.target.dataset.active
        } else if (e.target.parentNode.dataset.active) {
          id = e.target.parentNode.dataset.active
        } else {
          id = ''
        }
        this.$emit('input', id)
      }
    }
}
</script>